"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IccAuthApi = void 0;
/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
const XHR_1 = require("./XHR");
const AuthenticationResponse_1 = require("../model/AuthenticationResponse");
class IccAuthApi {
    constructor(host, headers, fetchImpl) {
        this.host = host;
        this.headers = Object.keys(headers).map((k) => new XHR_1.XHR.Header(k, headers[k]));
        this.fetchImpl = fetchImpl;
    }
    setHeaders(h) {
        this.headers = h;
    }
    handleError(e) {
        throw e;
    }
    /**
     * Login using username and password
     * @summary login
     * @param body
     */
    login(body) {
        let _body = null;
        _body = body;
        const _url = this.host + `/auth/login` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR_1.XHR.Header('Content-Type', 'application/json'));
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => new AuthenticationResponse_1.AuthenticationResponse(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Logout
     * @summary logout
     */
    logout() {
        let _body = null;
        const _url = this.host + `/auth/logout` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => new AuthenticationResponse_1.AuthenticationResponse(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Logout
     * @summary logout
     */
    logoutPost() {
        let _body = null;
        const _url = this.host + `/auth/logout` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl)
            .then((doc) => new AuthenticationResponse_1.AuthenticationResponse(doc.body))
            .catch((err) => this.handleError(err));
    }
    /**
     * Get token for subsequent operation
     * @summary token
     * @param method
     * @param path
     */
    token(method, path) {
        let _body = null;
        const _url = this.host + `/auth/token/${encodeURIComponent(String(method))}/${encodeURIComponent(String(path))}` + '?ts=' + new Date().getTime();
        let headers = this.headers;
        return XHR_1.XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl)
            .then((doc) => JSON.parse(JSON.stringify(doc.body)))
            .catch((err) => this.handleError(err));
    }
}
exports.IccAuthApi = IccAuthApi;
//# sourceMappingURL=IccAuthApi.js.map